
import { Typography, Box } from "@mui/material";

//progress bar
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { green, yellow, red } from '@mui/material/colors';

//Style 
const theme = createTheme({
    palette: {
        green: {
            main: green[500],
        },
        yellow: {
            main: yellow[500],
        },
        red: {
            main: red[500]
        },
    },
});

const BorderLinearProgress = styled(LinearProgress)(({ }) => ({
    height: 10,
    borderRadius: 5,
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
    },
}));

function LinearProgressWithLabel(props) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <BorderLinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary">{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

const ProgressBar = (props) => {
    return (
        <ThemeProvider theme={props?.theme || theme}><LinearProgressWithLabel value={props.value} color={props.color} /></ThemeProvider>
    )
}

export default ProgressBar;